import { render, staticRenderFns } from "./IndividuellesGallery.vue?vue&type=template&id=6c5230a8&scoped=true&"
import script from "./IndividuellesGallery.vue?vue&type=script&lang=js&"
export * from "./IndividuellesGallery.vue?vue&type=script&lang=js&"
import style0 from "./IndividuellesGallery.vue?vue&type=style&index=0&id=6c5230a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5230a8",
  null
  
)

export default component.exports